<!--
무자료 등록(재고방식) > 상품리스트
------------------------------------
-->
<template>

    <div class="">
        <div class="guide">
            <h2>
                <i class="material-icons">info</i>
                <span class="uk-text-middle">상품을 하나씩 추가하세요</span>
            </h2>
        </div>

        <!-- 리스트 -->
        <div class="uk-width-1-1 uk-padding">
            <div class="uk-flex uk-flex-bottom uk-flex-between">
                <div class="list-header">
                    <i class="material-icons">
                        list
                    </i>
                    무자료 상품({{ prods.length }})
                </div>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    @click="$refs.add.form(box)"
                >
                    <i class="material-icons">add_circle</i>
                    무자료 상품추가
                </button>

                <!-- 상품추가 컴포넌트 -->
                <add-prod
                    ref="add"
                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    :region-code="regionCode"
                    :session-owner="sessionOwner"
                    :prod-count="prodCount"
                    @added="prod => listenAdded(prod)"
                >
                </add-prod>
            </div>

            <div class="list">
                <!-- 등록 없음 안내 -->
                <div
                    v-show="prods.length === 0"
                    class="uk-padding-large uk-text-center uk-text-large uk-text-muted"
                >
                    등록된 상품이 없습니다
                </div>

                <!-- 상품 -->
                <prod
                    v-for="prod in prods"
                    :key="prod.id"

                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    :session-owner="sessionOwner"
                    :prod="prod"

                    @removed="prod => listenRemoved(prod)"
                    @updated="prod => listenUpdated(prod)"
                >
                </prod>
            </div>
        </div>



        <!-- 버튼 -->
        <div class="uk-margin uk-text-center">
            <button
                type="button"
                class="uk-button uk-button-large uk-button-danger uk-margin-large-right"
                @click="cancel"
                :disabled="prods.length > 0"
                title="등록된 상품이 없을때만 취소가능"
            >
                <i class="material-icons">close</i>
                취소
            </button>
            <button
                type="button"
                class="uk-button uk-button-large uk-button-primary"
                @click="done"
                :disabled="prods.length === 0"
            >
                <i class="material-icons">check</i>
                모든 상품 등록완료
            </button>
        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'add-prod': require('./add-prod.vue').default,
            'prod': require('./prod.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * 지역코드
             * (미국 커스텀때문에 추가됨)
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },

            // 첨부파일용 로그인(세션)ID
            sessionOwner: Number,

            // 박스 회원사 닉네임
            boxUserNick: String,

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 등록된 상품정보 배열
             */
            prods: {
                type: Array,
            },

            /**
             * 상품 수 (품목)
             */
            prodCount: {
                type: Number,
            },
        },
        data: function () {
            return {

            };
        },
        computed: {

        },
        methods: {
            /**
             * 취소처리
             */
            cancel() {
                // 이벤트 발생
                this.$emit('cancel');
            },

            /**
             * 완료처리
             */
            done() {
                // 이벤트 발생
                this.$emit('done');
            },

            /**
             * 상품추가 이벤트 리스너
             * @param prod
             */
            listenAdded(prod) {
                // 리스트에 추가
                this.prods.push(prod);

                // 첫번째 상품이면, 보관장소저장
                if (this.prods.length === 1) {
                    this.box.storage = prod.storage;
                }

                // 미국은 부분무자료 1개 등록 후 바로 보관라벨 출력
                if (this.regionCode === 2) {
                    this.done();
                }
            },

            /**
             * 상품삭제 이벤트 리스너
             * @param prod
             */
            listenRemoved(prod) {
                // 리스트에 제거
                let key = _.findIndex(this.prods, {id: prod.id});
                if (key < 0) {
                    alert('제거할 index of array 를 찾지 못했습니다');
                } else {
                    this.prods.splice(key, 1);
                }


                // 첫번째 상품이면, 보관장소제거
                if (this.prods.length === 0) {
                    this.box.storage = null;
                }
            },

            /**
             * 상품수정 이벤트 리스너
             * @param prod
             */
            listenUpdated(prod) {
                // 리스트에서 교체
                let key = _.findIndex(this.prods, {id: prod.id});
                if (key < 0) {
                    alert('교체할 index of array 를 찾지 못했습니다');
                } else {
                    this.prods.splice(key, 1, prod);
                }
            },
        },


    }
</script>

<style lang="scss" scoped>
    .guide {
        margin: 1rem;

        h2 {
            margin: 0;

            text-align: center;
            font-size: 1.25rem;
            color: #000;

            .material-icons {
                font-size: 1.5rem;
            }
        }
    }

    .list-header {
        font-size: 1.25rem;
        .material-icons {
            font-size: 1.5rem;
        }
    }
    .list {
        background-color: #fff;
        padding: 20px;
        border: 1px solid #cfcfcf;
    }
</style>